import type { CellRendererParams } from '@/grid/types';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

type ShipmentNumberLinkProps = {
  shipmentId: string | null | undefined;
  shipmentNumber: string | null | undefined;
};

export const ShipmentNumberLink = ({
  shipmentId,
  shipmentNumber,
}: ShipmentNumberLinkProps) => {
  const isEnabled = useFeatureFlag('Semen_Add_Shipment_Hyperlink');

  if (!shipmentNumber) return <>{shipmentNumber ?? ''}</>;

  if (!isEnabled || !shipmentId) return <>{shipmentNumber}</>;

  return (
    <a
      href={`/shipping/shipment?id=${shipmentId}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 hover:underline"
      onClick={(e) => e.stopPropagation()}
    >
      {shipmentNumber}
    </a>
  );
};

export const ShipmentNumberLinkRenderer = (
  params: CellRendererParams<{
    id?: string | null;
  }>,
) => (
  <ShipmentNumberLink
    shipmentId={params.data?.id}
    shipmentNumber={params.value as string | null | undefined}
  />
);
